import React from 'react';

const ReactProject =({react}) => {
    const { a, b, c, d, e, f, g, h, i, j, k, l, m, url,name,n,o,p,q,r,s,t,u,v,w} = react;
    return (
        <div className="col-md-4 p-3">
            <div className="serviceLi bg text-center text-white pt-3 pb-3">
            <h4 className="pb-3">{name}</h4>
             <div className="price">
             <span>${v}</span>
             </div>
                <div className="text-center mt-5">
                <ul> <li>{n}</li></ul>
                <ul> <li>{o}</li></ul>
                <ul> <li>{p}</li></ul>
                <ul> <li>{w}</li></ul>
                <ul> <li>{q}</li></ul>
                <ul> <li>{r}</li></ul>
                <ul> <li>{s}</li></ul>
                <ul> <li>{b}</li></ul>
                <ul> <li>{t}</li></ul>
                <ul> <li>{u}</li></ul>
                <ul> <li>{k}</li></ul>
                <ul> <li>{l}</li> </ul>
                <ul> <li>{m}</li> </ul>
                <button className="mt-5"><a href={url}>BUY</a></button>
                </div>
            </div>
         
        </div>
    );
};

export default ReactProject;